
import React, { useEffect } from "react";
import NavBar from "@/components/NavBar";
import HeroSection from "@/components/HeroSection";
import ExploreSection from "@/components/ExploreSection";
import MentorsSection from "@/components/MentorsSection";
import TeamSection from "@/components/TeamSection";
import CtaSection from "@/components/CtaSection";
import Footer from "@/components/Footer";

const Index = () => {
  useEffect(() => {
    // Log when Index page renders
    console.log("Index page rendered");
    
    // Check if the navbar and other components are rendering
    const navbarElement = document.querySelector('nav');
    console.log("Navbar found:", !!navbarElement);
    
    const mainElement = document.querySelector('main');
    console.log("Main content found:", !!mainElement);
  }, []);

  return (
    <div className="flex flex-col min-h-screen w-full">
      <NavBar />
      <main className="flex-grow">
        <HeroSection />
        <ExploreSection />
        <MentorsSection />
        <TeamSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
